<script setup lang="ts">
import BaseSlideViewport from '../base/BaseSlideViewport.vue'
import BaseSlideArea from '../base/BaseSlideArea.vue'
import StepperProgressPart from '../ui/StepperProgressPart.vue'

interface Props {
  progress?: string[]
}

const props = withDefaults(defineProps<Props>(), {})

const emit = defineEmits(['click-viewport'])
</script>

<template>
  <BaseSlideViewport @click="emit('click-viewport')">
    <BaseSlideArea class="grid grid-rows-[1fr_10%]">
      <div class="relative">
        <slot></slot>
      </div>
      <div class="relative flex justify-center items-center">
        <div v-if="progress" class="w-full py-2 px-4">
          <StepperProgressPart class="opacity-65" :progress />
        </div>
      </div>
    </BaseSlideArea>
  </BaseSlideViewport>
</template>
